var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgdFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0001C0 6.26806 6.26806 0 14 0C21.7319 0 28 6.26806 28 14.0001",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52174 7.30427C8.52174 5.26453 9.95526 3.56058 11.8695 3.1425C11.5696 3.07681 11.2635 3.0436 10.9565 3.04346C8.60322 3.04346 6.69561 4.95107 6.69561 7.30432C6.69561 9.65758 8.60322 11.5652 10.9565 11.5652C11.27 11.5652 11.5753 11.5304 11.8695 11.4661C9.95526 11.048 8.52174 9.34406 8.52174 7.30427ZM14 3.34779L14.3022 4.27775H15.2801L14.4889 4.85257L14.7911 5.78254L14 5.20782L13.2089 5.78254L13.5111 4.85257L12.72 4.27775H13.6978L14 3.34779Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6279 5.17383L11.9301 6.10384H12.9079L12.1168 6.67861L12.419 7.60857L11.6279 7.03386L10.8367 7.60857L11.139 6.67861L10.3478 6.10384H11.3257L11.6279 5.17383ZM16.3721 5.17383L16.6744 6.10384H17.6522L16.861 6.67861L17.1633 7.60857L16.3721 7.03386L15.581 7.60857L15.8832 6.67861L15.0921 6.10384H16.0699L16.3721 5.17383ZM15.4591 7.91296L15.7613 8.84298H16.7391L15.948 9.41774L16.2502 10.3477L15.4591 9.77299L14.668 10.3477L14.9702 9.41774L14.1791 8.84298H15.1569L15.4591 7.91296ZM12.5409 7.91296L12.8431 8.84298H13.821L13.0298 9.41774L13.3321 10.3477L12.5409 9.77299L11.7498 10.3477L12.052 9.41774L11.2609 8.84298H12.2387L12.5409 7.91296Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgdFlag);
export default __webpack_public_path__ + "static/media/SGDFlag.ea92bf9b11ed03bbd3e0712c253763ab.svg";
export { ForwardRef as ReactComponent };